var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_4366)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_73_4366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5656 15.3656L11.1312 16.8L12.5656 18.2344L11.4344 19.3656L10 17.9312L8.56562 19.3656L7.43442 18.2344L8.86882 16.8L7.43442 15.3656L8.56562 14.2344L10 15.6688L11.4344 14.2344L12.5656 15.3656ZM18.9656 15.3656L17.8344 14.2344L16.4 15.6688L14.9656 14.2344L13.8344 15.3656L15.2688 16.8L13.8344 18.2344L14.9656 19.3656L16.4 17.9312L17.8344 19.3656L18.9656 18.2344L17.5312 16.8L18.9656 15.3656ZM5.03442 14.2344L3.60002 15.6688L2.16562 14.2344L1.03442 15.3656L2.46882 16.8L1.03442 18.2344L2.16562 19.3656L3.60002 17.9312L5.03442 19.3656L6.16562 18.2344L4.73122 16.8L6.16562 15.3656L5.03442 14.2344ZM5.20002 9.99999V4.39999H6.80002V3.59999C6.80002 1.83519 8.23522 0.399994 10 0.399994C11.7648 0.399994 13.2 1.83519 13.2 3.59999V4.39999H14.8V9.99999C14.8 11.3232 13.7232 12.4 12.4 12.4H7.60002C6.27682 12.4 5.20002 11.3232 5.20002 9.99999ZM8.40002 4.39999H11.6V3.59999C11.6 2.71759 10.8824 1.99999 10 1.99999C9.11762 1.99999 8.40002 2.71759 8.40002 3.59999V4.39999ZM6.80002 9.99999C6.80002 10.4408 7.15842 10.8 7.60002 10.8H12.4C12.8416 10.8 13.2 10.4408 13.2 9.99999V5.99999H6.80002V9.99999ZM10.8 7.59999H9.20002V9.19999H10.8V7.59999Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_4366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_73_4366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(0.399902 0.399994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotp);
export default __webpack_public_path__ + "static/media/TOTP.c5771831c7f23ce16c902b445bc208e8.svg";
export { ForwardRef as ReactComponent };